
import styled from 'styled-components';

import { SingleBlock } from '@process-advisor/process-miner/components/layout/singleBlock';
import { Section } from '@process-advisor/process-miner/components/shared/section';
import { Button } from '@process-advisor/process-miner/components/shared/button';
import { StepLabels } from '@process-advisor/process-miner/settings/processMiner/stepLabels';
import { StepTooltip } from '@process-advisor/process-miner/settings/processMiner/stepTooltip';

import { StepLabelFontSize } from '@process-advisor/process-miner/settings/processMiner/stepLabelFontSize';
import { NodeLabelFontSize } from '@process-advisor/process-miner/settings/processMiner/nodeLabelFontSize';
import { DurationFormat } from '@process-advisor/process-miner/settings/processMiner/durationFormat';
import { NodeLabels } from '@process-advisor/process-miner/settings/processMiner/nodeLabels';
import { Colors } from '@process-advisor/process-miner/settings/processMiner/colors';
import { StartLabel } from '@process-advisor/process-miner/settings/processMiner/startLabel';
import { EndLabel } from '@process-advisor/process-miner/settings/processMiner/endLabel';
import { Nodes } from '@process-advisor/process-miner/settings/processMiner/nodes';
import { Spacing } from '@process-advisor/process-miner/settings/processMiner/spacing';
import { ZoomToFit } from '@process-advisor/process-miner/settings/processMiner/zoomToFit'
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { ProcessFlowDirection } from '@process-advisor/process-miner/settings/processMiner/processFlowDirection';
import { getShadow, getZIndex } from '@process-advisor/process-miner/shared/theme';
import { AlertMessage } from '@process-advisor/process-miner/components/alerts/alert';

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
`;


export const VisualizerSettings = () => {

    const resetVisualizerSettings = () => {
        apiProvider.resetVisualizerSettings()
        apiProvider.setProcessFlowDirection({ direction: 90 });
        apiProvider.alertMessage({message: 'Visualizer settings reset', severity: 'success', showAlert: true, timeOutActive: true, component: 'settings_visualizer'} )
    };

    return (
    <Wrapper>
        <SingleBlock width="20%">
            <Section title='Flow Direction'/>
        </SingleBlock>
        <SingleBlock width="80%">
            <ProcessFlowDirection />
        </SingleBlock>
        <SingleBlock width="20%">
            <Section title='Spacing'/>
        </SingleBlock>
        <SingleBlock width="80%">
            <Spacing />
        </SingleBlock>
        <SingleBlock width="20%">
            <Section title='Step Labels'/>
        </SingleBlock>
        <SingleBlock width="80%">
            <StepLabels/>
        </SingleBlock>
        <SingleBlock width="20%">
            <Section title='Step Toolip'/>
        </SingleBlock>
        <SingleBlock width="80%">
            <StepTooltip/>
        </SingleBlock>
        <SingleBlock width="20%">
            <Section title='Show Start Label'/>
        </SingleBlock>
        <SingleBlock width="30%">
            <StartLabel/>
        </SingleBlock>
        <SingleBlock width="20%">
            <Section title='Show End Label'/>
        </SingleBlock>
        <SingleBlock width="30%">
            <EndLabel/>
        </SingleBlock>        
        <SingleBlock width="20%">
            <Section title='Step Label Font Size'/>
        </SingleBlock>
        <SingleBlock width="80%">
            <StepLabelFontSize/>
        </SingleBlock>
        <SingleBlock width="20%">
            <Section title='Nodes'/>
        </SingleBlock>
        <SingleBlock width="80%">
            <Nodes />
        </SingleBlock>
        <SingleBlock width="20%">
            <Section title='Node Labels'/>
        </SingleBlock>
        <SingleBlock width="80%">
            <NodeLabels/>
        </SingleBlock>
        <SingleBlock width="20%">
            <Section title='Node Label Font Size'/>
        </SingleBlock>
        <SingleBlock width="80%">
            <NodeLabelFontSize/>
        </SingleBlock>
        <SingleBlock width="20%">
            <Section title='Duration Format'/>
        </SingleBlock>
        <SingleBlock width="80%">
            <DurationFormat/>
        </SingleBlock>
        <SingleBlock width="20%">
            <Section title='Colors'/>
        </SingleBlock>
        <SingleBlock width="80%">
            <Colors />
        </SingleBlock>
        <SingleBlock width="20%">
            <Section title='Zoom to fit'/>
        </SingleBlock>
        <SingleBlock width="80%">
            <ZoomToFit />
        </SingleBlock>
     
        <SingleBlock width="20%"/>
        <SingleBlock width="60%">
            <Button label='Reset Settings' onClick={resetVisualizerSettings}/>
        </SingleBlock>
        <SingleBlock width="20%"/>
        <AlertMessage/>
    </Wrapper>
    );
};
